import { FC, memo } from 'react';
import { useInterval } from 'react-use';

import { useSecureJsonCollectionsStore } from '@/shared/lib/sj-orm/stores/secureJsonCollections.store';
import { useSynchronizer } from '@/shared/lib/sj-orm/synchronizer/hooks/useSynchronizer';
import { useSyncQueueStore } from '@/shared/lib/sj-orm/synchronizer/sync-queue.store';
import { AddJobProps } from '@/shared/lib/sj-orm/synchronizer/types';

import { useCollectionsInitializer } from './hooks/useCollectionsInitializer';
import { useErrorHandlers } from './hooks/useErrorHandlers';
import { usePreventUnload } from './hooks/usePreventUnload';
import { getJobMethodByOperationType } from './helpers';

const ADD_JOB_INTERVAL_MS = 2000;
const SYNC_INTERVAL_MS = 3000;

export const CollectionsContainer: FC = memo(() => {
  const sjcStore = useSecureJsonCollectionsStore();
  const syncQueueStore = useSyncQueueStore();
  const synchronizer = useSynchronizer();

  useErrorHandlers();
  usePreventUnload();
  useCollectionsInitializer();

  useInterval(() => {
    synchronizer.sync();
  }, SYNC_INTERVAL_MS);

  // Checking updates and job for syncing collection
  useInterval(() => {
    const operations = sjcStore.operations;
    if (operations.length) {
      operations.forEach((iOperation) => {
        const jobData: AddJobProps = {
          method: getJobMethodByOperationType(iOperation.operationType),
          collectionName: iOperation.collectionName,
          item: iOperation.item,
        };

        syncQueueStore.addJob(jobData);
      });

      sjcStore.clearOperations();
    }
  }, ADD_JOB_INTERVAL_MS);

  return <>{null}</>;
});

CollectionsContainer.displayName = 'CollectionsContainer';
